(function() {
  // Accordion toggle
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('.mmc-accordion__trigger');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    var accordion = trigger.closest('.mmc-accordion');
    if (accordion) {
      accordion.classList.toggle('is-open');
    }
  });

  // Prevent menu link clicks from bubbling up to the body-level
  // delegated handler that closes the menu on any click inside
  // [data-show-mobile-menu="true"]
  document.addEventListener('click', function(e) {
    var link = e.target.closest('.mmc-drawer a[href]');
    if (link) {
      e.stopPropagation();
    }
  }, true);

  // --- Mobile search overlay ---
  var overlay = document.querySelector('[data-mmc-search-overlay]');
  if (!overlay) return;

  // Move overlay to body so it escapes the mobile header stacking context
  document.body.appendChild(overlay);

  var input = overlay.querySelector('[data-mmc-search-input]');
  var form = overlay.querySelector('[data-mmc-search-form]');
  var resultsWrapper = overlay.querySelector('[data-mmc-search-results]');
  var trending = overlay.querySelector('[data-mmc-trending]');
  var debounceTimer = null;

  function openOverlay() {
    overlay.classList.add('is-open');
    setTimeout(function() { input.focus(); }, 100);
    trending.style.display = '';
    resultsWrapper.innerHTML = '';
    resultsWrapper.style.display = 'none';
  }

  function closeOverlay() {
    overlay.classList.remove('is-open');
    input.value = '';
    resultsWrapper.innerHTML = '';
    resultsWrapper.style.display = 'none';
    trending.style.display = '';
  }

  // Open trigger
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-mmc-search-open]')) {
      e.preventDefault();
      e.stopPropagation();
      openOverlay();
    }
  });

  // Close trigger
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-mmc-search-close]')) {
      e.preventDefault();
      e.stopPropagation();
      closeOverlay();
    }
  });

  // Trending pill tap — fill input and show predictive results (don't navigate)
  document.addEventListener('click', function(e) {
    var pill = e.target.closest('[data-mmc-trending-pill]');
    if (!pill) return;
    e.preventDefault();
    e.stopPropagation();
    var keyword = pill.getAttribute('data-mmc-trending-pill');
    input.value = keyword;
    input.focus();
    fetchResults(keyword);
  });

  // Predictive search on input
  input.addEventListener('input', function() {
    var term = input.value.trim();
    clearTimeout(debounceTimer);
    if (term.length === 0) {
      resultsWrapper.innerHTML = '';
      resultsWrapper.style.display = 'none';
      trending.style.display = '';
      return;
    }
    debounceTimer = setTimeout(function() {
      fetchResults(term);
    }, 200);
  });

  function fetchResults(term) {
    if (!term || term.length === 0) return;
    trending.style.display = 'none';
    var url = window.PXUTheme.routes.predictive_search_url
      + '?q=' + encodeURIComponent(term)
      + '&section_id=predictive-search';
    fetch(url)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var results = doc.querySelector('.search__results');
        var allBtn = doc.querySelector('.all-results');
        if (results || allBtn) {
          resultsWrapper.innerHTML = '';
          if (results) resultsWrapper.appendChild(results);
          if (allBtn) resultsWrapper.appendChild(allBtn);
          resultsWrapper.style.display = 'block';
        } else {
          var noResults = doc.querySelector('.no-results');
          resultsWrapper.innerHTML = noResults ? noResults.outerHTML : '';
          resultsWrapper.style.display = 'block';
        }
      });
  }

  // Submit form
  form.addEventListener('submit', function(e) {
    var term = input.value.trim();
    if (term.length === 0) {
      e.preventDefault();
    }
  });
})();
